import { M8PartnerDTO } from 'services/production/types';
import { Partner, PartnerProfile, PartnersTableItem } from 'types/state';
import { normalizeM8PartnerStatus } from 'services/production/utils/normalizeM8PartnerStatus';
import { normalizeProfileLike } from 'utils/profileLikeUtils';

export const normalizeM8PartnerDTO = (m8PartnerDTO: M8PartnerDTO) => ({
  toPartnersTableItem(): PartnersTableItem {
    return {
      id: m8PartnerDTO.id,
      fullName: normalizeM8PartnerDTO(m8PartnerDTO).toFullName(),
      email: m8PartnerDTO.email,
      phone: m8PartnerDTO.phone || '',
      status: normalizeM8PartnerStatus(
        m8PartnerDTO.partnerStatus
      ).toPartnerStatus(),
      clientsCount: m8PartnerDTO.clientsCount,
      earnedAmount: m8PartnerDTO.earned,
      paidAmount: m8PartnerDTO.paidOut,
      balance: m8PartnerDTO.balance,
      latestUpdateDate: m8PartnerDTO.updatedOn,
    };
  },
  toFullName(): string {
    return normalizeProfileLike({
      lastName: m8PartnerDTO.lastName || '',
      firstName: m8PartnerDTO.firstName || '',
      middleName: m8PartnerDTO.middleName || '',
    }).toFullName();
  },
  toPartnerProfile(avatarURL?: string): PartnerProfile {
    return {
      avatarURL: avatarURL || null,
      firstName: m8PartnerDTO.firstName || '',
      lastName: m8PartnerDTO.lastName || '',
      middleName: m8PartnerDTO.middleName || '',
      phone: m8PartnerDTO.phone || '',
      country: m8PartnerDTO.country || null,
      city: m8PartnerDTO.city || '',
      details: m8PartnerDTO.aboutMyself || '',
    };
  },
  toPartner(avatarURL?: string): Partner {
    return {
      id: m8PartnerDTO.id,
      code: m8PartnerDTO.partnerCode || '',
      createdOnDate: m8PartnerDTO.createdOn,
      updatedOnDate: m8PartnerDTO.updatedOn,
      profile: normalizeM8PartnerDTO(m8PartnerDTO).toPartnerProfile(avatarURL),
    };
  },
});
